module.exports = __webpack_public_path__ + "img/06086f5.jpg";